import dayjs from "dayjs";
import { useDispatch } from "react-redux";

import { SelectSimple } from "@components/Selects";
import DatePicker from "@components/DatePicker/DatePickerCustom";
import { useMyTranslation } from "@components/Lang";
import { filterDeviceDetailAction } from "@reduxs/Actions/monitoringAction";
import { filterDeviceDetailInterface } from "@reduxs/interface";
import { DatePick, TextDatePick } from "./styles";

interface IMetricFilterControls {
  filterDeviceDetail: filterDeviceDetailInterface;
  plan: number;
  listUnit: { value: string; label: React.ReactNode; disabled?: boolean }[];
  listPeriod: { value: string; label: string }[];
}

// The unit / date / period controls of the metric-detail filter bar — identical
// across the 4 metric pages. Reads filterDeviceDetail + plan and dispatches
// filterDeviceDetailAction on change; the date window depends on `plan`.
export default function MetricFilterControls({
  filterDeviceDetail,
  plan,
  listUnit,
  listPeriod,
}: IMetricFilterControls) {
  const { t } = useMyTranslation();
  const dispatch = useDispatch();
  return (
    <>
      <div className="detail__period">
        <SelectSimple
          id="unit"
          labelText={t("detail.unit")}
          value={filterDeviceDetail.unit}
          options={listUnit}
          placeholder={t("detail.all")}
          classNameWarp=""
          onChange={(e) => {
            if (e === "weeks") {
              dispatch(
                filterDeviceDetailAction({
                  ...filterDeviceDetail,
                  unit: e,
                  date: dayjs().subtract(1, "day"),
                })
              );
            } else {
              dispatch(
                filterDeviceDetailAction({
                  ...filterDeviceDetail,
                  unit: e,
                })
              );
            }
          }}
        />
      </div>
      <div className="detail__period">
        <DatePick id="date-search">
          <TextDatePick>{t(`filter.${filterDeviceDetail.unit}`)}</TextDatePick>
          <DatePicker
            allowClear={false}
            value={filterDeviceDetail.date}
            picker={
              filterDeviceDetail.unit === "hours" ||
              filterDeviceDetail.unit === "days"
                ? "date"
                : filterDeviceDetail.unit === "weeks"
                ? "week"
                : "month"
            }
            format={
              filterDeviceDetail.unit === "hours" ||
              filterDeviceDetail.unit === "days"
                ? "DD/MM/YYYY"
                : filterDeviceDetail.unit === "weeks"
                ? "YYYY-wo"
                : "MM/YYYY"
            }
            disabledDate={(current) => {
              return (
                current > dayjs() ||
                current < dayjs().subtract(plan === 1 ? 3 : 12, "month")
              );
            }}
            getPopupContainer={() =>
              document.getElementById("date-search") as HTMLElement
            }
            onChange={(e) => {
              const d = new Date();
              let period = filterDeviceDetail.period;
              if (
                dayjs().isSame(e, "date") &&
                filterDeviceDetail.period > d.getHours()
              ) {
                period = d.getHours();
              }
              dispatch(
                filterDeviceDetailAction({
                  ...filterDeviceDetail,
                  date: e,
                  period: period,
                })
              );
            }}
          />
        </DatePick>
      </div>
      <div className="detail__period">
        <SelectSimple
          id="period"
          labelText={t("detail.periodtime")}
          value={filterDeviceDetail.period}
          options={listPeriod}
          placeholder={t("detail.all")}
          classNameWarp=""
          disabled={filterDeviceDetail.unit === "hours" ? false : true}
          onChange={(e) => {
            dispatch(
              filterDeviceDetailAction({
                ...filterDeviceDetail,
                period: e,
              })
            );
          }}
        />
      </div>
    </>
  );
}
